/**
 * Pinned stack for generated apps (must stay in sync with
 * LlmPromptBuilder SharedSystemPrompt + CreateModePrompt/EditModePrompt,
 * AgentLayerPrompts.LockedStackRules + CreateModeRules/EditModeRules,
 * and sandbox/Dockerfile.react-base).
 *
 * Bootstrap / follow-up instructions are system prompts on the backend —
 * do NOT prepend them to user chat messages.
 */
export const GENERATED_APP_STACK = Object.freeze({
  vite: '5.4.2',
  vitePluginReact: '4.3.1',
  react: '18.3.1',
  reactDom: '18.3.1',
  reactRouterDom: '6.26.1',
  axios: '1.7.7',
  zustand: '4.5.5',
  reduxToolkit: '2.2.7',
  reactRedux: '9.1.2',
  framerMotion: '11.3.30',
  lucideReact: '0.468.0',
  clsx: '2.1.1',
  reactHookForm: '7.52.2',
  reactIcons: '5.3.0',
  tailwindcss: '3.4.10',
  postcss: '8.4.41',
  autoprefixer: '10.4.20',
  tailwindForms: '0.5.7',
  tailwindTypography: '0.5.13',
  node: '>=20'
});

/**
 * First user message for a new project: short human brief only.
 * Stack + scaffolding rules are applied server-side as system prompts.
 */
export const buildProjectBootstrapMessage = (name, description) => {
  const trimmedName = name?.trim() || '';
  const trimmedDescription = description?.trim() || '';
  const brief = [trimmedName, trimmedDescription].filter(Boolean).join('\n\n');
  if (brief) {
    return `این پروژه را از صفر بساز و همه فایل‌های لازم را خودت بنویس.\n\n${brief}`;
  }
  return 'این پروژه را از صفر بساز: یک وب‌سایت کامل، زیبا و قابل اجرا با تمام فایل‌های لازم.';
};

/**
 * Optional short UI hint for follow-up requests (not sent to the model).
 */
export const DEFAULT_FOLLOW_UP_PROMPT =
  'پروژه را کامل‌تر کن: بخش‌های ناقص را اضافه کن و تجربه کاربری را بهتر کن.';

/** Pass-through — follow-up rules are system prompts, not user-message wrappers. */
export const buildFollowUpUserMessage = (userRequest) => userRequest?.trim() || '';

/** Alias used by chat + project form utils */
export const buildDefaultFollowUpPrompt = buildFollowUpUserMessage;
